import { Injectable } from '@angular/core';
import { Route, Router, ActivatedRouteSnapshot,
         RouterStateSnapshot, CanActivate, CanActivateChild,
         CanLoad } from '@angular/router';

import { AuthService }      from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})

export class LoggedInGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;

    return this.checkLogin(url);
  }

  private checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn()) { 
      if(localStorage.getItem('role_name') != "partner" && localStorage.getItem('role_name') != "supplier"){
        this.router.navigate(['/page-not-found',  { queryParams: { user: 'customer' } }]);
        return false;
      }
      return true
    }else{
      this.authService.redirectUrl = url;
      this.router.navigate(['/login']);
      return false;
    }
  }
}
